var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.154 5.154a.826.826 0 000 1.168L10.833 12l-5.679 5.678a.826.826 0 001.168 1.168L12 13.167l5.678 5.679a.826.826 0 001.168-1.168L13.167 12l5.679-5.678a.826.826 0 00-1.168-1.168L12 10.833 6.322 5.154a.826.826 0 00-1.168 0z",
    fill: "#424242",
    stroke: "#424242",
    strokeWidth: 0.175
  })));
}
export default SvgClose;